import { useState } from "react";
import { encrypt, receiveIV} from '../encryption'
import axios from "axios";


export function SmartForm({ fields, endpoint, defaultJson, depreciationNotice = []}) {
	
	const initialFormData = Object.fromEntries(
		fields.map(f => [f.name, f.value || ""])
	  );
	  
	const [formData, setFormData] = useState(initialFormData);
	const [jsonText, setJsonText] = useState(defaultJson || "{}");
	const [debugLog, setDebugLog] = useState([]);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [isExpanded, setIsExpanded] = useState(false);


	const submitForm = async function (endpoint, encrypted,IV) {
		const requestData = {k: encrypted + IV};
		let response;
		try {
			const axiosConfig = {
			method: endpoint.type.toLowerCase(),
			url: "https://rest.hodlbot.org/api" + endpoint.url,
			headers: requestData
			};
			const res = await axios(axiosConfig);
			response = res.data;
		} catch (err) {
			response = err.response?.data || { error: 'Unknown error' };
			console.log(err.message);
		}
		return response;
	};

	const submitSequence = async (e) => {
		e.preventDefault(); // prevent form reload
		if (!jsonText) {
			alert("Fill in some parameters first")
			return
		}
		//const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
		setLoading(true)
		setDebugLog([]) // reset log
		//proceed to login with the API
		appendLog("step 1: requesting IV")
		let IV = await receiveIV()
		updateDebugLog(1,`Step 1: IV received: ${IV}`)
		appendLog("step 2: start encryption")
		const jsonObject = JSON.parse(jsonText)
		const jsonText2 = JSON.stringify(jsonObject);
		let encrypted = await encrypt(jsonText2,IV)
		updateDebugLog(2,`Step 2: Encryption completed: ${encrypted.length} chars`)
		appendLog("step 3: Prepare to submit!")
		let response = await submitForm(endpoint,encrypted,IV)
		console.log("got back:",response)
		const respjsonText = JSON.stringify(response, null, 2);
		console.log("to string:", respjsonText)
		if (response.success || response.status === "ok") {
			updateDebugLog(3,`Step 3: feedback received: ${response.status}`)
			appendLog(" ")
			appendLog(respjsonText)
		} else {
			updateDebugLog(3,`Step 3: error received:`)
			appendLog(" ")
			appendLog(respjsonText)
		}
		setLoading(false)
		return
	}

	const handleJSONchange = (e) => {
		const { value } = e.target;
		//setJsonText(JSON.stringify(value, null, 2));
		setJsonText(value);
	}

	const appendLog = (message) => {
		setDebugLog((prev) => [...prev, message]);
	};
	
	const updateDebugLog = (position, newText) => {
		const index = position - 1; // shift from 1-based to 0-based
		setDebugLog(prevLog => {
			if (index < 0 || index >= prevLog.length) return prevLog;
			const updatedLog = [...prevLog];
			updatedLog[index] = newText;
			return updatedLog;
		});
	};
	
	const toggleExpand = () => {
		if (isExpanded) {setIsExpanded(false)}
		else {setIsExpanded(true)}
	}

	const handleChange = (e) => {
		const { name, value } = e.target;
	  
		// Step 1: Update formData
		const updated = { ...formData, [name]: value };
	  
		// Step 2: Apply exclusivity rules across all fields
		const cleaned = { ...updated };
		fields.forEach((field) => {
		  if (field.exclusiveWith?.includes(name)) {
			delete cleaned[field.name];
		  }
		  if (field.name === name && field.exclusiveWith) {
			field.exclusiveWith.forEach(ex => {
			  delete cleaned[ex];
			});
		  }
		});
	  
		// Step 3: Validate all fields
		const newErrors = {};
		fields.forEach((field) => {
		  const val = cleaned[field.name];
		  if (field.regex && val && !field.regex.test(val)) {
			newErrors[field.name] = "Invalid format";
		  }
		});
	  
		setFormData(cleaned);
		setErrors(newErrors);
	  
		// Step 4: Filter valid fields for jsonText
		const filtered = Object.fromEntries(
		  Object.entries(cleaned).filter(([key, val]) => {
			const f = fields.find(f => f.name === key);
			if (!f) return false;
	  
			const isObsolete = f.exclusiveWith?.some(ex => cleaned[ex]);
			const isInvalid = f.regex && val && !f.regex.test(val);
	  
			return val !== undefined && !isObsolete && !isInvalid;
		  })
		);
	  
		setJsonText(JSON.stringify(filtered, null, 2));
	  };
	
	
	const handleOLDChange = (e) => {
		const { name, value } = e.target;

		const field = fields.find(f => f.name === name);
		const updated = { ...formData, [name]: value };

		// Clear mutually exclusive fields
		if (field?.exclusiveWith) {
			field.exclusiveWith.forEach(ex => {
				delete updated[ex];
			});
		}

		// Validate with regex
		let newErrors = { ...errors };
		if (field?.regex && !field.regex.test(value)) {
			newErrors[name] = "Invalid format";
		} else {
			delete newErrors[name];
		}

		setFormData(updated);
		setErrors(newErrors);

		// Filter out exclusive or invalid fields
		const filtered = Object.fromEntries(
			Object.entries(updated).filter(([key, val]) => {
				const f = fields.find(f => f.name === key);
				if (!f) return false;

				const isObsolete = f?.exclusiveWith?.some(ex => updated[ex]);
				const isInvalid = f?.regex && !f.regex.test(val);
				if (f.type === "hidden") {
					console.log("hidden field is:",isObsolete," or ",isInvalid)
					return !isObsolete && !isInvalid;
				  }
				return val && !isObsolete && !isInvalid;
			})
		);
		console.log("filtered:",filtered)
		setJsonText(JSON.stringify(filtered, null, 2));
	};
	//setDebugText(["line 1","line 2"])
	return (
		<div className="smartform">
			<form onSubmit={submitSequence}>
				<div className="header" onClick={toggleExpand}>
					<span className="headerLeft">
						{isExpanded ? '🔽' : '▶️'} {endpoint.human}
					</span>
				  <span className="headerRight">
						{endpoint.type} @ {endpoint.url}
					</span>
				</div>
				{isExpanded && (
				<>
				<div className="input-row">
					<div className="form-left">
						{fields.map((field) => {
							if (field.type === "hidden") {
								return (
	  								<input
									key={field.name}
									type="hidden"
									name={field.name}
									value={field.value || formData[field.name] || ""}
	  								/>
								);
  							}
						return (
						<div key={field.name}>
							{field.type === "hidden" ? (

								<input
								key={field.name}
								type="hidden"
								name={field.name}
								value={field.value || formData[field.name] || ""}
								/>)
							:""}
							{field.type === "select" ? (
								<>
								<label>{field.label}:</label>
								<select
									name={field.name}
									value={formData[field.name] || ""}
									onChange={handleChange}
								>
									<option value="">-- select --</option>
									{field.options.map(opt =>
										typeof opt === "string" ? (
											<option key={opt} value={opt}>{opt}</option>
										) : (
											<option key={opt.value} value={opt.value}>{opt.label}</option>
										)
									)}
								</select>
								</>
							) : (
								<>
								<label>{field.label}:</label>
								<input
									type={field.type}
									name={field.name}
									value={formData[field.name] || ""}
									onChange={handleChange}
								/>
								</>
							)}
							{errors[field.name] && (
								<div style={{ color: "red", fontSize: "0.8em" }}>{errors[field.name]}</div>
							)}
						</div>
					);
							})}
					</div>
					<div className="form-right">
						<label className="intro">or edit the JSON directly:</label><br />
						<textarea
							value={jsonText}
							onChange={handleJSONchange}
							rows={5}
						/>
					</div>
				</div>

				{depreciationNotice.length > 0 && (
  					<div className="depreciation-section">
    					<h4>Depreciation Notice</h4>
    					<table>
      						<tbody>
								{depreciationNotice.map((notice, idx) => (
						          	<tr key={idx}>
						            	<td>
						              		{notice.date}
						            	</td>
						            	<td>
						              		{notice.text}
						            	</td>
						          	</tr>
						        ))}
	     						</tbody>
    					</table>
  					</div>
				)}
				<div className="form-submit">
					<button type="submit" disabled={loading}>
			          {loading ? "Processing..." : "Submit Request to API"}
			        </button>
				</div>
				<div className="result">
					<label className="intro">Results:</label><br/>
		    	<pre className="feedback">
						{debugLog.join("\n")}
		      </pre>
				</div>
			</>
			)}
			</form>
		</div>
	);
}